/**
 * Colba = CauseOfLossBurglarAlarm
 */

// Setup the namespace for this logic
var causeOfLossBurglarAlarmHelper = causeOfLossBurglarAlarmHelper || {};


causeOfLossBurglarAlarmHelper.initialize = function() {
	ap.consoleInfo("causeOfLossBurglarAlarmHelper initialize!");

	// Register onChange event handlers for Cause of Loss field.
	causeOfLossBurglarAlarmHelper.colbaRegisterFieldChangeEvent("BuildingCauseOfLoss", causeOfLossBurglarAlarmHelper.colbaCauseOfLossOnChange);
	causeOfLossBurglarAlarmHelper.colbaRegisterFieldChangeEvent("BurglarAlarmType", causeOfLossBurglarAlarmHelper.colbaBurglarAlarmOnChange);
};


causeOfLossBurglarAlarmHelper.colbaRegisterFieldChangeEvent = function(fieldId, functionRef) {  
	var field = page.getField(fieldId);
	if (field == null) {
    	return;
	}
	var elements = field.getElements();
	for (var ix in elements) {
		var element = elements[ix];
		if (element) {
		    ap.registerEvent(element, 'change', functionRef);
		}
	}
};

//Handles Cause of Loss change.
causeOfLossBurglarAlarmHelper.colbaCauseOfLossOnChange = function(event) {
	var fieldId = this.id;
	if (fieldId==null || fieldId=="") {
		fieldId = event.srcElement.id;
	}
	
	var field = page.getField(fieldId);
	if (field !== null) {
		//Retrieve the Burglar Alarm field.
		var burglarAlarmField = page.getField("BurglarAlarmType");
		
		//Reset the burglar alarm field value whenever the Cause of Loss field has changed.
		if(burglarAlarmField != null) {
			burglarAlarmField.setValue("");
		}
		field.makeIntraPageDTRRequest();
	}
};

// Handles burglar alarm change.
causeOfLossBurglarAlarmHelper.colbaBurglarAlarmOnChange = function(event) {
	var fieldId = this.id;
	if (fieldId==null || fieldId=="") {
		fieldId = event.srcElement.id;
	}
	
	var field = page.getField(fieldId);
	
	// If Burglar Alarm was changed to Local or None, issue IPDTR to kick off behaviors which
	//   will exclude the Burglar Alarm field AND set Cause of Loss to Special - Excluding Theft.
	if (field != null && ("L" == field.getValue() || "N" == field.getValue())) {
		field.makeIntraPageDTRRequest();
	}
};
